var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrueIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4995 0C5.59533 0 0 5.59635 0 12.5005C0 19.4037 5.59533 25 12.4995 25C19.4037 25 24.999 19.4037 24.999 12.5005C24.999 5.59635 19.4037 0 12.4995 0ZM19.906 7.78688L11.4429 19.0467C11.1785 19.3976 10.7757 19.6182 10.3374 19.6508C10.2988 19.6538 10.2612 19.6548 10.2235 19.6548C9.82488 19.6548 9.44047 19.4992 9.1547 19.2175L4.44515 14.5924C3.84412 14.0015 3.83497 13.0364 4.42582 12.4354C5.01668 11.8334 5.98178 11.8263 6.5828 12.4151L10.0506 15.8209L17.4674 5.95228C17.9738 5.27905 18.9297 5.1438 19.604 5.64923C20.2762 6.15771 20.4125 7.11366 19.906 7.78688Z",
    fill: "#006AB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueIconActive);
export default __webpack_public_path__ + "static/media/trueIconActive.de32de34a95d318e829e384f39fe1440.svg";
export { ForwardRef as ReactComponent };